import { useCallback } from "react";

const useReplaceScopeOfWorkIds = () => {
  const replaceDuplicateIdFromScopeOfWork = useCallback(targetDOM => {
    if (!targetDOM) return;

    const uniqueWidgetId = `${Math.random().toString(36).substring(2, 9)}`;

    const inputs = targetDOM.querySelectorAll("input[id*='custom-scope-item'], input[id*='custom-section']");

    inputs.forEach(input => {
      const baseId = input.id.replace(/-[a-z0-9]{7}$/i, "");

      // Make a new ID
      const newId = `${baseId}-${uniqueWidgetId}`;
      input.id = newId;

      if (input.name) {
        const baseName = input.name.replace(/-[a-z0-9]{7}$/i, "");
        input.name = `${baseName}-${uniqueWidgetId}`;
      }

      const label = input.closest(".custom-control")?.querySelector("label");
      if (label) {
        label.setAttribute("for", newId);
      }
    });

    return targetDOM;
  }, []);

  return replaceDuplicateIdFromScopeOfWork;
};

export default useReplaceScopeOfWorkIds;
